export const CONFIG = JSON.parse(process.env.CONFIG || '{}');
export const REDUX_STORAGE_KEY = '__REDUX_STORAGE__';

export enum USER_TYPE {
  UNKNOWN = 'unknown',
  PREDEFINED = 'predefined',
  LISTENER = 'listener',
}

export enum USER_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum USER_ROLES {
  ADMIN = 'admin',
  SPEAKER = 'speaker',
  HOST = 'host',
  LISTENER = 'listener',
}

export enum ROOM_STATUS {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  CANCELLED = 'canceled',
  ON_AIR = 'onAir',
  FINISHED = 'finished',
}

export const INVOKER_SECRET = 'x-invoker-secret';

export type LISTENERS_TYPE_OPTIONS_KEYS = keyof typeof LISTENERS_TYPE_OPTIONS;
export type CATEGORIES_OPTIONS_KEYS = keyof typeof CATEGORIES_OPTIONS;
export type CONSTANT_ROOM_OPTIONS_KEYS = keyof typeof CONSTANT_ROOM_OPTIONS;
export type STATUS_OPTIONS_KEYS = Exclude<ROOM_STATUS, ROOM_STATUS.ON_AIR>;
export type DURATION_LIMIT_OPTIONS_KEYS = keyof typeof DURATION_LIMIT_OPTIONS;

export const LISTENERS_TYPE_OPTIONS = {
  openToAll: 'פתוח לכולם',
  // registeredOnly: 'רשומים בלבד',
  // payingOnly: 'משלמים בלבד',
} as const;

export const CATEGORIES_OPTIONS = {
  news: 'חדשות',
  culture: 'תרבות',
  sport: 'ספורט',
  economy: 'כלכלה',
  digital: 'דיגיטל',
  connect: 'יחסים',
  other: 'אחר',
};

export const STATUS_OPTIONS: Record<STATUS_OPTIONS_KEYS, string> = {
  active: 'פעיל',
  inactive: 'לא פעיל',
  canceled: 'מבוטל',
  finished: 'הסתיים',
};

export const CONSTANT_ROOM_OPTIONS = {
  all: 'הכל',
  constant: 'חדרים קבועים',
  oneTimeRoom: 'חד פעמי',
};

export const DURATION_LIMIT_OPTIONS = {
  '30': 'חצי שעה',
  '60': 'שעה',
  '90': 'שעה וחצי',
  '120': 'שעתיים',
  '150': 'שעתיים וחצי',
  '180': '3 שעות',
};
